<script setup>
const props = defineProps({ blok: Object })
const textColorClasses = computed(() => {
  switch (props.blok.color) {
    case 'yellow':
      return '!text-yellow-500'
    case 'blue':
      return '!text-blue-500'
    case 'green':
      return '!text-green-500'
    default:
      return '!text-secondary-red-100 '
  }
})
const bgClasses = computed(() => {
  switch (props.blok.theme) {
    case 'light-gray':
      return 'bg-secondary-gray-50'
    case 'dark-navy':
      return 'bg-primary'
    default :
      return 'bg-white'
  }
})

const paddingClasses = computed(() => {
  switch (props.blok.padding) {
    case 'padding-top':
      return 'pt-mobile lg:pt-desktop'
    case 'padding-both':
      return 'py-mobile lg:py-desktop'
    default :
      return 'pb-mobile lg:pb-desktop'
  }
})
</script>

<template>
  <div :class="[bgClasses, paddingClasses]">
    <div class="pt-5 container lg:pt-10 md:pt-10">
      <div
        v-if="blok.header"
        class="mb-1 text-center text-md font-bold capitalize lg:text-xl md:text-xl sm:text-lg" :class="textColorClasses"
      >
        {{ blok.header }}
      </div>
      <h2 v-if="blok.title" class="mx-auto text-center text-3xl font-bold lg:max-w-4xl md:max-w-2xl sm:max-w-xl md:text-4xl xl:text-5xl">
        {{ blok.title }}
      </h2>
      <span v-if="blok.title" class="mx-auto mb-custom-xl mt-3 block h-[3px] w-14 rounded-full bg-secondary-red-100 sm:mt-4 sm:w-16" />
      <CardImage :card="blok.product" />
    </div>
  </div>
</template>
